export default __webpack_public_path__ + "static/media/CNCMachineImg.39567b13.jpg";